import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";

import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputTextArea from "../../helpers/InputTextArea";
import InputTextAreaRadio from "../../helpers/InputTextAreaRadio";
import InputChecbox from "../../helpers/InputCheckbox";

import InputCombo from "../../helpers/InputCombo";
import InputRadioButton from "../../helpers/InputRadioButton";
import InputKidsMultiE from "../../helpers/InputKidsMultiE";

import back from "../../back.png";
import g_juz_spie from "../../alerts/juz_spie_z.png";
import g_obudzilem_sie from "../../alerts/obudzilem_sie_z.png";
import g_ide_na_spacer from "../../alerts/ide_na_spacer_z.png";
import g_wrocilem from "../../alerts/wrocilem_z.png";
import g_mam_bieginke from "../../alerts/mam_biegunke_z.png";
import g_kupka from "../../alerts/kupka_z.png";
import g_mam_goraczke from "../../alerts/mam_goraczke_z.png";

import InputDateTime from "../../helpers/InputDateTime";

function AlertsNew(props)
{
    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [tab, setTab] = useState();
    const [tabSelected, setTabSelected] = useState(props.tabSelected);
    const [view, setView] = useState(props.view);


    if(view!==props.view)
    {
        setView(props.view)
    } 

  
    const [row, setRowX] = useState({
       
        
        tresc: '',
        tresc_valid: false,
        def_text: '',
        def_text_valid: false,
        

    });
    var tmpRow = row;

    const [checked1, setChecked] = useState(false);
    const handleChange = () => {
        setChecked(!checked1);
      };

     

      const [checkedR1, setCheckedR1] = useState(false);
      const handleChangeR1 = () => {
            setCheckedR1(!checkedR1);
          };     
     

   

    const valChecker = (fields) => {

        var allValid = true;

              
        

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                //console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }
    const saveData = () => {


        if(!valChecker(tmpRow))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
     
        if(wybrane.length< 1)
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz odbiorców wiadomości"  ,  "ok"  ,null); 
                return;
            }
    
    
            var data = [];

                        wybrane.forEach( (item) => {
                            data.push({
                                p_dziecko_id: item.id,
                                typ: tmpRow.def_text	,
                                info: tmpRow.tresc,
                            });
                        } )

                        

                

        const sendData = {
            ev: data
        }

             
        props.mainView.setProgress(-2);
        
        

        var req = tmpRow;

        fetch( Config.url + '/rest,emp_add_event', {
            method: 'POST', 
            body: JSON.stringify(sendData), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Powiadomienie zostało wysłane.", "ok" , null);         
                        
                        //getTab();
                        //Config.removeFromBuffer( Config.cache_kids_search, props.userData );                        
                      
                        props.onBack('reload');
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
    
    var wybrane = props.tabSelected.filter(tabSelected => tabSelected.selected === 1);

   


    const valChangeListenerMulti = (filedName, val, correct, msg,filedName2, val2, correct2, msg2) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
        //console.log("valChangeListener: " + filedName2 + " " + val2 + ", correct: " + correct2 + ", msg: " + msg);

        setRowX( {...tmpRow, [filedName]:val,  [filedName+"_valid"]:correct,[filedName2]:val2,  [filedName2+"_valid"]:correct2 } );
        
        var modX = val.length % 3;
        if(  val.length == 0 || modX == 0 || msg =='combo')
        setTab(null);  

        props.mainView.writeFilter(filedName, val);
    }

    const goNextNew = () => {
        
        setTab(null);    
    }

    const [optionStaf, setoptionStaf]  = useState([
        {
            i: 0,
            v: 'SLEEP',
            title: (<img src={g_juz_spie}></img>),
            text: 'Już spię',
        },
        {
            i: 1,
            v: 'AWAKE',
            title: (<img src={g_obudzilem_sie}></img>),
            text: 'Obudził(em/am) się'
        },
        {
            i: 2,
            v: 'WALK',
            title: (<img src={g_ide_na_spacer}></img>),
            text: 'Idę na spacerek'
        }
        ,
        {
            i: 3,
            v: 'BACK',
            title: (<img src={g_wrocilem}></img>),
            text: 'Jestem już z powrotem'
        }
        ,
        {
            i: 4,
            v: 'SHI',
            title: (<img src={g_mam_bieginke}></img>),
            text: 'Mam biegunkę'
        }
        ,
        {
            i: 5,
            v: 'KKP',
            title: (<img src={g_kupka}></img>),
            text: 'Zrobił(em/am) kupkę'
        }
        ,
        {
            i: 6,
            v: 'TEMP',
            title: (<img src={g_mam_goraczke}></img>),
            text:'Mam gorączke'
        }
        
    ]
    );

    const [optionDone, setoptionDone]  = useState([
        {
            v: '0',
            title: 'NIE'
        },
        {
            
            v: '1',
            title: "TAK"
        }
    ]
    );

    const goChange = () => {
        props.onBack("dialog");    
        
    }

    const closeDialog = () => {       
        props.onBack('link');
        
    }

    if(view=='link')
    {
        return (
            <div className="btn btn_full" onClick={goChange}  v="new" t='W' id="-1"  >Wyślij powiadomienie</div>
        )
    }

    var is_mobile = props.mainView.isMobile();

    if(is_mobile) 
    {
        return (

            <div className="view_content">


                    <form className="eForm bg_center">
                        <div className="mobile_form_tab form_tab">
                            <div className="form_tab_title">Wyślij powiadomienie bbb (wybrano: {wybrane.length})
 
                            </div>
                                             
                                <div className="form_control">

                                

                                <div className="form_split"></div>    

                                <div className="filter_controll">   
                                    <label>Szczegoły: </label>                             
                                    <InputTextAreaRadio  userData={props.userData} items={optionStaf} checked={row.def_text} mainView={props.mainView} err={errTab}  value={row.tresc} className='w400 h100'   valChange={valChangeListenerMulti}  radio="def_text" goNext={goNextNew} name="tresc" placeholder={"Treść: "}  req='1'  />
                                </div>

                                
                              
                                </div>

                                    


                        </div>


 

                            <div className="form_split"></div>

                            <div className="form_btn">
                                <div className="btn" onClick={props.onBack} onClick={saveData}> wyślij </div>
                                <div className="btn btn_back" onClick={closeDialog}    > wróć</div>
                            </div>




                    </form>


            </div>
        )
    }
    else{
        return (

            <div className="dlg_window dlg_type_x shadowx">
                <div className="dlg_title">Wyślij powiadomienie aaa(wybrano: {wybrane.length})</div>
                <div className="dlg_content_x">
                <form className="eForm bg_center">
                        <div className="mobile_form_tab form_tab">
                           
                                             
                                <div className="form_control">

                                

                                <div className="form_split"></div>    

                                <div className="filter_controll">   
                                    <label>Szczegoły: </label>                             
                                    <InputTextAreaRadio  userData={props.userData} items={optionStaf} checked={row.def_text} mainView={props.mainView} err={errTab}  value={row.tresc} className='w400 h100'   valChange={valChangeListenerMulti}  radio="def_text" goNext={goNextNew} name="tresc" placeholder={"Treść: "}  req='1'  />
                                </div>

                                
                              
                                </div>

                                    


                        </div>


 

                            <div className="form_split"></div>

                            <div className="form_btn">
                                <div className="btn" onClick={props.onBack} onClick={saveData}> wyślij </div>
                                &nbsp; &nbsp;
                                <div className="btn btn_back" onClick={closeDialog}    > anuluj</div>
                            </div>

                    </form>
                </div>
            </div>
    )
    }

    

}


export default AlertsNew;


